export { RoomImageCarousel } from './index.pc'
export { MobileRoomImageCarousel } from './index.mobile'
